import _ from 'lodash';

export const getWorkflowName = (workflowType) => {
  switch (workflowType) {
    case 'fccase':
      return 'FCCase';
    case 'ccase':
      return 'CCase';
    case 'batch':
      return 'Batch';
    case 'payment':
      return 'Payment';
    case 'activity':
      return 'Activity';
    case 'loan':
      return 'Loan';
    default:
      return '';
  }
};

export const getCreateEvent = (workflowType, config) => ({
  allowedAction: 'create',
  type: `states.events.payloads/com.vymo.tech.${workflowType}.model.${_.capitalize(
    workflowType,
  )}.json`,
  config,
});

export const formatReadableDate = (value) => {
  if (!value) {
    return '-';
  }
  const d = new Date(value);
  const day = d.getDate();
  const month = d.toLocaleString('en-US', { month: 'short' });
  const year = d.getFullYear();

  const time = d.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${day} ${month}, ${year} at ${time}`;
};

export const getColumnView = (value, type) => {
  switch (type) {
    case 'date':
    case 'date_range_v2':
      return formatReadableDate(value);
    default:
      return value;
  }
};

export const getEntityDetailsDefaultState = () => ({
  profileCardData: { header: [], body: [] },
  inputsMap: {},
  referredDoDetails: [],
  profiles: [],
  allowedActions: [],
  quickActions: [],
  activities: {},
  referredEntityDetails: [],
});
